export interface AssemblyOption {
  value: string;
  name: string;
  description: string;
}

export interface Fragment {
  color: string;
  name: string;
}

export enum ASSEMBLY_TYPE {
  DIGEST = 'DIGEST',
  GIBSON = 'GIBSON',
  GOLDEN_GATE = 'GOLDEN_GATE',
}
